import { parse, format } from 'date-fns'
import itLocale from 'date-fns/locale/it'

export const isDateInstance = (date) => date instanceof Date && !isNaN(date)

export const getDateIsoString = (
  dateString,
  t,
  parseString = t('common.date.formatDMY')
) => {
  if (!dateString) {
    return null
  }
  let date = new Date(dateString)

  if (isDateInstance(date)) {
    return date.toISOString()
  }

  date = parse(dateString, parseString, new Date(), {
    locale: itLocale,
  })
  if (isDateInstance(date)) {
    return date.toISOString()
  }

  return null
}

export const formatDate = (t, date) =>
  date
    ? format(new Date(date), t('common.date.formatDMY'), {
        locale: itLocale,
      })
    : ''
